<i18n lang="yaml" locale="en">
  name: Name
  user: User
  actions: Actions
  create project: Create project
  attention: Attention!
  confirm delete project: Do you really want to delete this project?
  enter new project name: Please enter the new project name.
  project limit reached: Maximum number of projects reached.
  project name: Project name
  enter project name: Please enter the project name.
  copy: "{name} (Copy)"
</i18n>

<i18n lang="yaml" locale="de">
  name: Name
  user: Nutzer
  actions: Aktionen
  create project: Projekt erstellen
  attention: Achtung!
  confirm delete project: Wollen Sie das Projekt wirklich löschen?
  enter new project name: Bitte geben Sie den neuen Namen des Projektes an.
  project limit reached: Maximale Anzahl an Projekten erreicht.
  project name: Projektname
  enter project name: Bitte geben Sie den Namen des Projektes an.
  copy: "{name} (Kopie)"
</i18n>

<template>
  <div class="project-manager">
    <table class="projects-table">
      <thead>
        <tr>
          <th>{{ $t('name') }}</th>
          <th>{{ $t('user') }}</th>
          <th>{{ $t('actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="project in projects"
          :key="project.id"
        >
          <td>
            <a
              :href="'/project/' + project.id"
              target="_blank"
            >{{ project.name }}</a>
          </td>
          <td>
            {{ project.user }}
          </td>
          <td>
            <copy
              size="s"
              @click="cloneProject(project.id, $t('copy', { name: project.name }))"
            />
            <settings
              size="s"
              @click="editProject(project.id)"
            />
            <share
              size="s"
              @click="exportTree(project.id)"
            />
            <delete
              size="s"
              color="danger"
              @click="deleteProject(project.id)"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <tw-button
      @click="toggleNewProjectPopup()"
      icon="add-circle"
      color="main"
    >
      {{ $t('create project') }}
    </tw-button>
  </div>
</template>

<script>
import axios from 'axios'
import Delete from '@/components/icons/Delete'
import Settings from '@/components/icons/Settings'
import Copy from '@/components/icons/Copy'
import Share from '@/components/icons/Share'
import TwButton from '@/components/ui/TwButton'
import { Prompt, Confirm, Error } from '@/plugins/snotify'

export default {
  name: 'ProjectManager',
  components: {
    Delete,
    Settings,
    Copy,
    Share,
    TwButton
  },
  data () {
    return {
      projects: null
    }
  },
  created () {
    this.fetchProjects()
  },
  methods: {
    deleteProject (id) {
      const requestDelete = () => {
        axios.delete('projects/' + id).then(() => {
          this.fetchProjects()
          this.$emit('dataChange')
        })
      }
      new Confirm(this.$t('attention'), this.$t('confirm delete project'), requestDelete).open()
    },
    editProject (id) {
      const oldName = this.projects.find(p => p.id === id).name
      const updateProjectName = (name) => {
        this.updateProject(id, { name })
      }
      new Prompt(oldName, this.$t('enter new project name'), updateProjectName, oldName).open()
    },
    async cloneProject (id, name) {
      try {
        await axios.post('/projects', { template: id, name })
        this.fetchProjects()
        this.$emit('dataChange')
      } catch (e) {
        if (e.response.status === 402) {
          new Error(this.$t('project limit reached')).open()
        } else {
          throw e
        }
      }
    },
    async fetchProjects () {
      const response = await axios.get('/projects')
      response.data.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      this.projects = response.data
    },
    toggleNewProjectPopup () {
      new Prompt(this.$t('project name'), this.$t('enter project name'), this.createProject).open()
    },
    async createProject (name) {
      try {
        await axios.post('/projects', { name })
        this.fetchProjects()
        this.$emit('dataChange')
      } catch (e) {
        if (e.response.status === 402) {
          new Error(this.$t('project limit reached')).open()
        } else {
          throw e
        }
      }
    },
    async updateProject (id, project) {
      await axios.patch('projects/' + id, project)
      this.fetchProjects()
    },
    exportTree (id) {
      window.location.replace(`/projects/${id}`)
    }
  }
}
</script>
